export default "__VITE_ASSET__BRAbc$lC__"